export default {"src":"/_next/static/media/help-square-dark.aedeffbc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};